export enum ErrorMessageTranslated {
  InvalidCredentials = "Pogrešna e-mail adresa ili lozinka",
}
